import React, { useContext, useRef } from 'react';
import { useQuery } from '@apollo/client';
import { faCheck, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import {
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  useResponsiveParams,
  MixedGridGroup,
  QuantaRadioGroup,
  QuantaInput,
  Text,
} from 'quanta-ui';
//import { ConfigContext } from '../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
//import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import {useMutationQuery} from 'quanta-flows';
//import Parse from '../../../../../lib/intl/CurrencyFormater';

import { CurrencyFormater } from 'quanta-flows';
import { Error, Loading } from 'quanta-flows/modules/layout';
import {
  CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL,
  CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL,
  FINANCER_DROPDOWN_DETAILS,
  GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  GET_CUSTOMER_TYPE_DOMAIN,
  GET_DATE_TIME,
  PREVIOUS_INSURER_COMPANY_LIST,
  //NOMINEE_DROPDOWN_DETAILS,
  PROPOSAL_PAYMENT_TYPE_LIST,
  SAVE_PROPOSAL_TW,
  SAVE_PROPOSAL,
  CHECK_IMD_CONFIG,
  PROFILE_DETAILS
} from '../queries';
//import { updatebuyHealthPolicy } from '../_graphql/state';
//import { updateBuyHealthPolicy } from '../_graphqlscpa/state';
import { updateBuyHealthPolicy } from 'quanta-flows/modules/proposal/health/state';
//import ProposerCustomerReadOnly from '../../../../common/proposer-customer/proposer-customer-readonly';
//import { P } from 'quanta-flows/modules/proposer-customer-readonly-a2f863cf';
import {ProposerCustomerReadOnly} from  'quanta-flows/modules/common/proposer/edit';
//import { P } from 'quanta-flows/modules/proposer-customer-readonly-a2f863cf';
import { useParams } from 'react-router-dom';
//import { P } from '../../../../../../../../quanta-flows/modules/proposer-customer-readonly-a2f863cf';
import { useFetchQuery } from 'quanta-flows';

export default function ReviewAndConfirmDetails({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  currentStepFunctions,
  setCurrentStepFunctions,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  productCode,
  lobCode,
  lobName,
  productName,
  productType,
  renderExpandedCards,
  ...props
}) {

  const params = useParams();
  //console.log('params data',params)

  const initLoadRef = useRef([]);
  const mutateQuery = useMutationQuery();
  const fetchQuery = useFetchQuery();
  const { branding } = useContext(QuantaConfigContext);
  const {
    loading: loadingPaymentType,
    error: errorPaymentType,
    data: dataPaymentType,
  } = useQuery(PROPOSAL_PAYMENT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });
  const {
    loading: loadingbuyHealthPolicy,
    error: errorbuyHealthPolicy,
    data: databuyHealthPolicy,
    previousData,
  } = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 2];
    },
  });
  const {
    loading: loadingDateTime,
    error: errorDateTime,
    data: dataDateTime,
    previousData: previousDateTime,
  } = useQuery(GET_DATE_TIME, {
    fetchPolicy: 'network-only',
    skip:
      databuyHealthPolicy &&
      databuyHealthPolicy?.buyHealthPolicy?.proposalNumber
        ? true
        : false,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 3];
    },
  });

  // const {
  //   loading: loadingNomineeDropdownDetails,
  //   error: errorNomineeDropdownDetails,
  //   data: dataNomineeDropdownDetails,
  // } = useQuery(NOMINEE_DROPDOWN_DETAILS, {
  //   fetchPolicy: 'cache-first',
  //   variables: {
  //     productCode: product_code || productCode,
  //   },
  //   onCompleted: (_) => {
  //     initLoadRef.current = [...initLoadRef.current, 4];
  //   },
  // });

  const {
    loading: loadingFinancerDropDownDetails,
    error: errorFinancerDropdownDetails,
    data: dataFinancerDropdownDetails,
  } = useQuery(FINANCER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 5];
    },
  });

  const {
    loading: loadingCustomerType,
    error: errorCustomerType,
    data: dataCustomerType,
  } = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 6];
    },
  });

  const {
    loading: loadingIndividualDropDownDetails,
    error: errorIndividualDropDownDetails,
    data: dataIndividualDropDownDetails,
  } = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 7];
    },
  });

  const {
    loading: loadingOrganisationDropDownDetails,
    error: errorOrganisationDropDownDetails,
    data: dataOrganisationDropDownDetails,
  } = useQuery(CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 8];
    },
  });

  const {
    loading: loadingPreviousInsurerDetails,
    error: errorPreviousInsurerDetails,
    data: dataPreviousInsurerDetails,
  } = useQuery(PREVIOUS_INSURER_COMPANY_LIST, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 9];
    },
  });
  const {
    loading: loadingProfile,
    error: loadingError,
    data: dataProfileData,
  } = useQuery(PROFILE_DETAILS, {
    fetchPolicy: 'network-only',

  });
  if (
    loadingPaymentType ||
    loadingbuyHealthPolicy ||
    loadingDateTime ||
    // loadingNomineeDropdownDetails ||
    loadingFinancerDropDownDetails ||
    loadingCustomerType ||
    loadingIndividualDropDownDetails ||
    loadingOrganisationDropDownDetails ||
    loadingPreviousInsurerDetails||
    loadingProfile
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }
  if (
    errorPaymentType ||
    errorbuyHealthPolicy ||
    errorDateTime ||
    // errorNomineeDropdownDetails ||
    errorFinancerDropdownDetails ||
    errorCustomerType ||
    errorIndividualDropDownDetails ||
    errorOrganisationDropDownDetails ||
    errorPreviousInsurerDetails
  ) {
    return (
      <div className="min-h-screen">
        <Error
          error={
            errorPaymentType ||
            errorbuyHealthPolicy ||
            errorDateTime ||
            // errorNomineeDropdownDetails ||
            errorFinancerDropdownDetails ||
            errorCustomerType ||
            errorIndividualDropDownDetails ||
            errorOrganisationDropDownDetails ||
            errorPreviousInsurerDetails
          }
        />
      </div>
    );
  }
  const {buyHealthPolicy}  = databuyHealthPolicy;
  //console.log('review_deframe',buyHealthPolicy)
  const { ProposalPaymentTypeList } = dataPaymentType;
  const { datetimeValue } = dataDateTime
    ? dataDateTime
    : previousDateTime
    ? previousDateTime
    : { time: null, date: buyHealthPolicy?.policy?.date };
  // const { PRD_NomiRelationWithMemb, PRD_ApointRelationWithMinNomi } =
  //   dataNomineeDropdownDetails;
  const { PRD_FinancerAgreementType, PRD_IsYourVehicle } =
    dataFinancerDropdownDetails;
  const { customerTypeList } = dataCustomerType;
  const {
    idProofTypeList,
    maritalStatusList,
    nationalityList,
    genderList,
    salutationList,
  } = dataIndividualDropDownDetails;
  const obj = { dataProfileData };
  const value = Object.values(obj);

  const mapUserId = value?.[0]?.userMyDetail?.userId;
  const { organisationList } = dataOrganisationDropDownDetails;
  const { rolloverCompanyList } = dataPreviousInsurerDetails;
  const validate = (values) => {
    return {};
  };
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toLowerCase() ===
        searchText?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toLowerCase() ===
            searchText?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const initialValues = {
    isProposalCreated:
      buyHealthPolicy?.proposalNumber?.length > 0 ? true : false,
    leadGenerator: buyHealthPolicy?.reviewAndConfirmTabDetails
      ?.leadGenerator
      ? `${buyHealthPolicy?.reviewAndConfirmTabDetails?.leadGenerator}`
      : '',
    proposalPaymentType: buyHealthPolicy?.reviewAndConfirmTabDetails
      ?.proposalPaymentType
      ? `${buyHealthPolicy?.reviewAndConfirmTabDetails?.proposalPaymentType}`
      : ProposalPaymentTypeList && ProposalPaymentTypeList?.length > 0
      ? ProposalPaymentTypeList[0]?.code
      : buyHealthPolicy?.proposalPaymentType
      ? buyHealthPolicy?.proposalPaymentType
      : '',
  };

  const getSaveProposalMutationVariables = (values) => {
    let arr = [];
    let con=0;
    const { warningMsg, ...restPremium } =
    buyHealthPolicy?.planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() === params?.plan_name?.toLowerCase(),
          )?.premium;
          const { isNewCustomer,isCRNVerified, ...restProposerMetaData } =
          buyHealthPolicy?.proposerDetailsMeta;
          buyHealthPolicy?.insuredDetails.map((r,idx) => {
            arr.push( {
              VehicleType : buyHealthPolicy?.quoteData.members?.[idx]?.relationship?.toString(),
              RegistrationNumber : r.vehicleRegNo.part1 + r.vehicleRegNo.part2 +
                                    r.vehicleRegNo.part3 + r.vehicleRegNo.part4,
              VehicleMakeModel :r.VehicleMake+'-'+ r.VehicleModel,
              EngineNo : r.EngineNo,
              ChasisNo : r.ChasisNo,
            });
          })
          //console.log('calculate arr',arr)
    //buyHealthPolicy?.coverData?.rawRiskData?.forEach((r) => {
  //let covers = [];
    //   r.covers
    //     .filter(
    //       (c) =>
    //         buyHealthPolicy?.coverData?.addOnCovers[c?.name]?.selected,
    //     )
    //     .forEach((c) => {
    //       const { selected, attributes, ...rest } = c;
    //       let attributesArr = [];
    //       c?.attributes?.forEach((attribute) => {
    //         attributesArr.push({
    //           ...attribute,
    //           value: attribute?.showOnScreen
    //             ? `${
    //                 buyHealthPolicy?.coverData?.addOnCovers[
    //                   `${c?.name}`
    //                 ][`attributes`][`${attribute?.name}`]
    //               }`
    //             : `${attribute?.defaultValue}`,
    //         });
    //       });
    //       covers.push({
    //         ...rest,
    //         attributes: [...attributesArr],
    //       });
    //     });
    //   if (covers?.length !== 0) {
    //     riskInput.push({
    //       riskType: r?.riskType,
    //       covers,
    //     });
    //   }
    // });
    return {
      input: {
        quoteNumber: buyHealthPolicy?.quoteNumber,
        proposalPaymentType: values?.proposalPaymentType,
        leadGenerator: values?.leadGenerator,
        UserId:mapUserId?mapUserId:'',
        proposerDetails: {
          ...restProposerMetaData,
          //...buyHealthPolicy?.proposerDetails,
          //proposerDetailsMeta:buyHealthPolicy?.proposerDetailsMeta,
          ...buyHealthPolicy?.proposerDetails,
          isThinCustomer: false,
          isCRNVerified : false
          //isCRNVerified : isCRNVerified === null ? false : 
                //isCRNVerified === "" ? false: isCRNVerified,
        },
        insuredDetails: arr,
        plan: {
          name: params?.plan_name,
          code: params?.plan_code,
          premium:restPremium,
          // premium: buyHealthPolicy?.planData?.plans?.find(
          //   (plan) =>
          //     plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
          // )?.premium,
        },
        intermediary: {
          intermediaryCode:buyHealthPolicy?.intermediaryDetails.code,
          locationCode:buyHealthPolicy?.intermediaryDetails.locationCode,
          fieldUserCode:buyHealthPolicy?.intermediaryDetails.fieldUserCode,
        },
        zone: buyHealthPolicy?.quoteData?.location?.zone?.trim(),
        quotationType: buyHealthPolicy?.quotationType,
        sumInsured: parseFloat(
          buyHealthPolicy?.quoteData?.cover?.sum_insured,
        ),
        startDate: Date.now(),
        startTime: '00:00',
        tenure: buyHealthPolicy?.quoteData?.cover?.tenure,
        coverType: buyHealthPolicy?.quoteData?.cover?.type,
        productCode: productCode,
        isExistingEmployee:
        buyHealthPolicy?.quoteData?.isExistingEmployee?.toLowerCase() ===
          'yes'
            ? true
            : false,
        existingPolicyNumber:
          buyHealthPolicy?.existingPolicyNumber,
        employeeNumber:
          buyHealthPolicy?.proposerDetails?.employeeNumber,
        proposerPincode:
          buyHealthPolicy?.quoteData?.location?.pincode,
          nomineeDetails:{
            name: buyHealthPolicy?.nomineeDetails?.[con]?.name,
            dob: buyHealthPolicy?.nomineeDetails?.[con]?.dob,
            relationshipWithInsured: buyHealthPolicy?.nomineeDetails?.[con]?.relationshipWithInsured,
            insuredRelationship: buyHealthPolicy?.nomineeDetails?.[con]?.insuredRelationship,
            nameOfAppointee: buyHealthPolicy?.nomineeDetails?.[con]?.nameOfAppointee,
            relationshipWithAppointee: buyHealthPolicy?.nomineeDetails?.[con]?.relationshipWithAppointee,
          },
          prevInsuranceDetails:
          {
            Name_of_Insurer: buyHealthPolicy?.prevInsuranceDetails?.[con]?.Name_of_Insurer,
            Existing_PA_Policy_Number: buyHealthPolicy?.prevInsuranceDetails?.[con]?.Existing_PA_Policy_Number,
            Existing_PA_Policy_Sum_Insured: buyHealthPolicy?.prevInsuranceDetails?.[con]?.Existing_PA_Policy_Sum_Insured,
            Existing_PA_Policy_Start_Date: buyHealthPolicy?.prevInsuranceDetails?.[con]?.Existing_PA_Policy_Start_Date,
            Existing_PA_Policy_End_Date: buyHealthPolicy?.prevInsuranceDetails?.[con]?.Existing_PA_Policy_End_Date,
            pastinsurername:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastinsurername,
            pastAddress:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastAddress,
            pastpolicynumber:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastpolicynumber,
            paststartdate:buyHealthPolicy?.prevInsuranceDetails?.[con]?.paststartdate,
            pastenddate:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastenddate,
            pastpropertydescription:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastpropertydescription,
            pastcauseofloss:'loss',
            pastlosslocation:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastlosslocation,
            pastamountofloss:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastamountofloss,
            pastsuminsured:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastsuminsured,
            pastpremium:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastpremium,
            pastOldData:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastOldData,
            pastDeleted:buyHealthPolicy?.prevInsuranceDetails?.[con]?.pastDeleted
          }
      },
    };
  };
  const onSubmit = async (values) => {
    if (!buyHealthPolicy?.proposalNumber) {
      try {
        setParentAlerts([]);
        /*SA Divya  CR P2_169A  : Check IMD Config*/
        let ImdConfigQuery = fetchQuery({
          query: CHECK_IMD_CONFIG,
          fetchPolicy: 'cache-first',
          variables: {
            intermediaryCode: buyHealthPolicy?.intermediaryDetails.code,
          },
        });
        setLoadingStep(true);
        let { data: dataImdCongig } = await ImdConfigQuery;
        setLoadingStep(false);
        if(dataImdCongig?.checkConfigImd?.isConfiguredIMD 
          && !values?.leadGenerator ){
          setParentAlerts([
            {
              header: 'Unable to Proceed',
              id: Date.now(),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  {`Lead generator is Mandatory. 
                  Please enter the Lead generator before Proceeding`}
                </div>
              ),
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
          return  false;
        };
        /*EA Divya CR P2_169A  : Check IMD Config*/
        const saveProposalMutation = mutateQuery({
          mutation: SAVE_PROPOSAL,
          variables: getSaveProposalMutationVariables(values),
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        updateBuyHealthPolicy({
          reviewAndConfirmTabDetails: values,
          renewalMandateDetails:
          {
            renewalPaymentMandate:false
          },
          proposalPaymentType: values.proposalPaymentType
        });
        setLoadingStep(true);
        setCustomLoadingMessage('Saving Proposal');
        const { data } = await saveProposalMutation;
        setLoadingStep(false);
        setCustomLoadingMessage(null);
        if (data?.saveProposalSCPA?.warningMsg) {
          setParentAlerts([
            {
              header: 'Proposal Saved Successfully',
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Proposal Number:{' '}
                    {data?.saveProposalSCPA?.proposalNumber}
                  </Text>
                </div>
              ),
              type: 'success',
              timeout: null,
              disableClose: false,
            },
            {
              content: (
                <Text type="normal">
                  {data?.saveProposalSCPA?.warningMsg}
                </Text>
              ),
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
        } else {
          setParentAlerts([
            {
              header: 'Proposal Saved Successfully',
              id: Date.now(),
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Proposal Number:{' '}
                    {data?.saveProposalSCPA?.proposalNumber}
                  </Text>
                </div>
              ),
              type: 'success',
              timeout: null,
              disableClose: false,
            },
          ]);
        }
        updateBuyHealthPolicy({
          reviewAndConfirmTabDetails: {
            ...values,
            isProposalCreated: true,
          },
          proposalPaymentType: values.proposalPaymentType,
          proposalNumber: data?.saveProposalSCPA?.proposalNumber,
          proposalStatus: data?.saveProposalSCPA?.proposalStatus,
          isProposalApplicableForPayment:
            data?.saveProposalSCPA?.isApplicableForPayment === null ||
            data?.saveProposalSCPA?.isApplicableForPayment ===
              undefined ||
            data?.saveProposalSCPA?.isApplicableForPayment
              ? true
              : false,
          policy: {
            startDate: datetimeValue?.date,
            endDate: data?.saveProposalSCPA?.proposalEndDate,
            time: datetimeValue?.time,
          },
          proposerDetails: {
            id: data?.saveProposalSCPA?.customerID,
          },
          premiumData: data?.saveProposalSCPA?.premium,
          renewalMandateDetails:
          {
            renewalPaymentMandate:false
          }
        });
        return true;
      } catch (error) {
        if(error?.message){
          if(error.message.includes("Unexpected token")){
            error.message='Please try again after sometime'
          }
        }
        setParentAlerts([
          {
            header: 'Error',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                {error.message}
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingStep(false);
        return false;
      }
    } else {
      return true;
    }
  };

  const ReviewAndConfirmForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const repeatForDesktop = 3,
      repeatForMobile = 2;
    const MINOR_THRESHOLD_AGE = 18;

    const repeat = useResponsiveParams({
      for_mobile: repeatForMobile,
      for_desktop: repeatForDesktop,
    });

    const reviewAndConfirmData = [
      {
        title: 'Review Proposal',
        grid_type: 'data',
        grid_data: [
          {
            label: 'Product Name',
            colSpan: repeat === repeatForMobile ? 2 : 1,
            text: productName,
          },
          {
            label: 'Business Type',
            text: buyHealthPolicy?.quoteData?.businessTypeValue
              ? buyHealthPolicy?.quoteData?.businessTypeValue
              : buyHealthPolicy?.quoteData?.quotationType,
          },
          {
            label: 'Policy Start Date',
            text: buyHealthPolicy?.policy?.startDate
              ? buyHealthPolicy?.policy?.startDate
              : datetimeValue?.date
              ? datetimeValue?.date
              : moment(new Date(), 'DD/MM/YYYY'),
          },
          // {
          //   label: 'IDV',
          //   text:
          //     buyHealthPolicy?.vehicleTabDetails
          //       ?.insuredDeclaredDetails?.vehicleIDV !== null
          //       ? CurrencyFormater(
          //           `${buyHealthPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV}`,
          //           true,
          //           false,
          //           branding,
          //         )
          //       : '',
          // },
          // {
          //   label: 'IRF1 Adjustment',
          //   text: buyHealthPolicy?.vehicleTabDetails
          //     ?.insuredDeclaredDetails?.irfAdjustmentPercent
          //     ? `${buyHealthPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent} %`
          //     : '',
          // },
          {
            label: 'Tenure',
            text:
              buyHealthPolicy?.quoteData?.cover?.tenure ||
              buyHealthPolicy?.quoteData?.premiumData?.tenure
                ? `${
                    buyHealthPolicy?.quoteData?.cover?.tenure ||
                    buyHealthPolicy?.quoteData?.premiumData?.tenure
                  } ${
                    (
                      buyHealthPolicy?.quoteData?.cover?.tenure ||
                      buyHealthPolicy?.quoteData?.premiumData?.tenure
                    )?.trim() === '1'
                      ? 'year'
                      : 'years'
                  }`
                : '',
          },
          // {
          //   label: 'Credit Score Discount',
          //   text:
          //     buyHealthPolicy?.quoteData?.getAdditionalCreditScore?.toLowerCase() ===
          //     'no'
          //       ? 'Not Availed'
          //       : 'Availed',
          // },
          buyHealthPolicy?.quoteData?.voluntaryDeductibleAmount !==
            null &&
          buyHealthPolicy?.quoteData?.voluntaryDeductibleAmount !==
            undefined &&
          buyHealthPolicy?.quoteData?.voluntaryDeductibleAmount !== ''
            ? {
                label: 'Voluntary Deductible Amount',
                text: CurrencyFormater(
                  buyHealthPolicy?.quoteData
                    ?.voluntaryDeductibleAmount,
                  true,
                  false,
                  branding,
                  true,
                ),
              }
            : null,
          {
            label: 'Proposal Type',
            colSpan:
              (buyHealthPolicy?.quoteData
                ?.voluntaryDeductibleAmount === null ||
                buyHealthPolicy?.quoteData
                  ?.voluntaryDeductibleAmount === undefined ||
                buyHealthPolicy?.quoteData
                  ?.voluntaryDeductibleAmount === '') &&
              repeat === repeatForDesktop
                ? 2
                : 1,
            text: (
              <QuantaRadioGroup
                name={'proposalPaymentType'}
                className={'mt-1'}
                disabledGlobal={
                  buyHealthPolicy?.proposalNumber?.length > 0
                }
                data={
                  ProposalPaymentTypeList &&
                  ProposalPaymentTypeList?.length > 0
                    ? ProposalPaymentTypeList?.map(
                        (proposalPaymentType) => {
                          return {
                            label: proposalPaymentType?.value
                              ? proposalPaymentType?.value
                              : '',
                            value: proposalPaymentType?.code
                              ? proposalPaymentType?.code
                              : '',
                          };
                        },
                      )
                    : []
                }
              />
            ),
          },
          {
            label: 'Lead Generator',
            colSpan: repeat === repeatForMobile ? 2 : 1,
            text: (
              <div className={'mt-1'}>
                <QuantaInput
                  type={'text'}
                  size={'full'}
                  name={'leadGenerator'}
                  disabled={
                    buyHealthPolicy?.proposalNumber?.length > 0
                  }
                />
              </div>
            ),
          },
        ]?.filter((d) => d),
      },
    ];

    // const proposerDetailsData = [
    //   buyHealthPolicy?.proposerDetailsMeta?.isNewCustomer === false
    //     ? {
    //         grid_type: 'data',
    //         grid_data: [
    //           {
    //             label: 'Customer Number',
    //             text: buyHealthPolicy?.proposerDetails?.id,
    //           },
    //           {
    //             label: 'CRN',
    //             text: buyHealthPolicy?.proposerDetailsMeta?.crn,
    //           },
    //         ],
    //       }
    //     : null,
    //   buyHealthPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: <Text type="normal">Personal Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Title',
    //             text: (
    //               <span>
    //                 {buyHealthPolicy?.proposerDetails?.title !== ''
    //                   ? getDomainData(
    //                       salutationList,
    //                       buyHealthPolicy?.proposerDetails?.title,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //           {
    //             label: 'Gender',
    //             text: (
    //               <span>
    //                 {buyHealthPolicy?.proposerDetails?.gender !== ''
    //                   ? getDomainData(
    //                       genderList,
    //                       buyHealthPolicy?.proposerDetails?.gender,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //           {
    //             label: 'Date of Birth',
    //             text: buyHealthPolicy?.proposerDetails?.proposerDOB,
    //           },
    //           {
    //             label: 'First Name',
    //             text: buyHealthPolicy?.proposerDetails?.firstName,
    //           },
    //           {
    //             label: 'Middle Name',
    //             text: buyHealthPolicy?.proposerDetails?.middleName,
    //           },
    //           {
    //             label: 'Last Name',
    //             text: buyHealthPolicy?.proposerDetails?.lastName,
    //           },
    //           {
    //             label: 'Marital Status',
    //             text: (
    //               <span>
    //                 {buyHealthPolicy?.proposerDetails
    //                   ?.maritalStatus !== ''
    //                   ? getDomainData(
    //                       maritalStatusList,
    //                       buyHealthPolicy?.proposerDetails
    //                         ?.maritalStatus,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //           {
    //             label: 'Nationality',
    //             text: (
    //               <span>
    //                 {buyHealthPolicy?.proposerDetails?.nationality !==
    //                 ''
    //                   ? getDomainData(
    //                       nationalityList,
    //                       buyHealthPolicy?.proposerDetails
    //                         ?.nationality,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //         ],
    //       }
    //     : {
    //         title: <Text type="normal">Organisation Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Organisation Name',
    //             text: buyHealthPolicy?.proposerDetails?.orgName,
    //           },
    //           {
    //             label: 'Organisation Type ',
    //             text: getDomainData(
    //               organisationList,
    //               buyHealthPolicy?.proposerDetails?.orgType,
    //               'code',
    //               'value',
    //             ),
    //           },
    //           {
    //             label: 'Contact Person Name',
    //             text: buyHealthPolicy?.proposerDetails?.contactName,
    //           },
    //         ],
    //       },
    //   buyHealthPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: <Text type="normal">Identification Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'ID Proof Type',
    //             text: (
    //               <span>
    //                 {buyHealthPolicy?.proposerDetails?.idProofType !==
    //                 ''
    //                   ? getDomainData(
    //                       idProofTypeList,
    //                       buyHealthPolicy?.proposerDetails
    //                         ?.idProofType,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //           {
    //             label: 'ID Proof Number',
    //             text: buyHealthPolicy?.proposerDetails?.idProofNumber
    //               ?.toString()
    //               ?.toUpperCase(),
    //           },
    //         ],
    //       }
    //     : {
    //         title: (
    //           <Text type="normal">Tax Identification Details</Text>
    //         ),
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Registration Number',
    //             text: buyHealthPolicy?.proposerDetails?.regNumber,
    //           },
    //           {
    //             label: 'TAN Number',
    //             text: buyHealthPolicy?.proposerDetails?.tanNumber?.toUpperCase(),
    //           },
    //           {
    //             label: 'GST Number',
    //             text: buyHealthPolicy?.proposerDetails?.gstNumber?.toUpperCase(),
    //           },
    //         ],
    //       },
    //   buyHealthPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: <Text type="normal">Internal Employee</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Employee Number',
    //             text: buyHealthPolicy?.proposerDetails?.employeeNumber
    //               ?.toString()
    //               ?.toUpperCase(),
    //           },
    //         ],
    //       }
    //     : null,
    //   buyHealthPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: (
    //           <Text type="normal">Tax Identification Details</Text>
    //         ),
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'PAN Card Number',
    //             text: buyHealthPolicy?.proposerDetails?.panNumber
    //               ?.toString()
    //               ?.toUpperCase(),
    //           },
    //           {
    //             label: 'GST Number',
    //             text: buyHealthPolicy?.proposerDetails?.gstNumber?.toUpperCase(),
    //           },
    //         ],
    //       }
    //     : null,
    //   {
    //     grid_type: 'data',
    //     isBorderRequired: true,
    //     borderClassName: 'border-t-2 border-neutral pt-4',
    //     grid_data: [
    //       {
    //         label: 'Permanent Address',
    //         colSpan: repeat,
    //         text: [
    //           buyHealthPolicy?.proposerDetails?.permAddressLine1?.trim(),
    //           buyHealthPolicy?.proposerDetails?.permAddressLine2?.trim(),
    //           buyHealthPolicy?.proposerDetails?.permAddressLine3?.trim(),
    //           buyHealthPolicy?.proposerDetails?.permLandmark?.trim(),
    //           buyHealthPolicy?.proposerDetails?.permCityTownVillage?.trim(),
    //           buyHealthPolicy?.proposerDetails?.permDistrict?.trim(),
    //           buyHealthPolicy?.proposerDetails?.permState?.trim(),
    //           buyHealthPolicy?.proposerDetails?.permPincode,
    //         ]
    //           .filter((a) => a)
    //           .join(','),
    //       },
    //       {
    //         label: 'Communication Address',
    //         colSpan: repeat,
    //         text: [
    //           buyHealthPolicy?.proposerDetails?.commAddressLine1?.trim(),
    //           buyHealthPolicy?.proposerDetails?.commAddressLine2?.trim(),
    //           buyHealthPolicy?.proposerDetails?.commAddressLine3?.trim(),
    //           buyHealthPolicy?.proposerDetails?.commLandmark?.trim(),
    //           buyHealthPolicy?.proposerDetails?.commCityTownVillage?.trim(),
    //           buyHealthPolicy?.proposerDetails?.commDistrict?.trim(),
    //           buyHealthPolicy?.proposerDetails?.commState?.trim(),
    //           buyHealthPolicy?.proposerDetails?.commPincode,
    //         ]
    //           .filter((a) => a)
    //           .join(','),
    //       },
    //     ].filter((d) => d),
    //   },
    //   buyHealthPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: <Text type="normal">Contact Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Mobile Number',
    //             text: buyHealthPolicy?.proposerDetails?.mobileNo,
    //           },
    //           {
    //             label: 'Email Id',
    //             text: buyHealthPolicy?.proposerDetails?.emailID,
    //           },
    //           !buyHealthPolicy?.proposalNumber
    //             ? {
    //                 colSpan: repeat,
    //                 label: <div className="mt-4"></div>,
    //                 text: (
    //                   <Text
    //                     severity="action"
    //                     className="hover:underline cursor-pointer"
    //                     onClick={(_) => {
    //                       goToStep(0);
    //                       window.scrollTo({
    //                         top: 0,
    //                         behavior: 'smooth',
    //                       });
    //                     }}
    //                   >
    //                     <FontAwesomeIcon
    //                       icon={faEdit}
    //                       className="mr-1"
    //                     />
    //                     <span className="font-bold">
    //                       Edit Details
    //                     </span>
    //                   </Text>
    //                 ),
    //               }
    //             : null,
    //         ].filter((d) => d),
    //       }
    //     : {
    //         title: <Text type="normal">Contact Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Telephone Number',
    //             text: buyHealthPolicy?.proposerDetails?.phoneNo,
    //           },
    //           {
    //             label: 'Organisation Mobile Number',
    //             text: buyHealthPolicy?.proposerDetails?.mobileNo,
    //           },
    //           {
    //             label: 'FAX Number',
    //             text: buyHealthPolicy?.proposerDetails?.faxNo,
    //           },
    //           {
    //             label: 'Alternative Telephone Number',
    //             text: buyHealthPolicy?.proposerDetails?.altPhoneNo,
    //           },
    //           {
    //             label: 'Alternative Mobile Number',
    //             text: buyHealthPolicy?.proposerDetails?.altMobileNo,
    //           },
    //           {
    //             label: 'Organisation Email Id',
    //             text: buyHealthPolicy?.proposerDetails?.emailID,
    //           },
    //           !buyHealthPolicy?.proposalNumber
    //             ? {
    //                 colSpan: repeat,
    //                 label: <div className="mt-4"></div>,
    //                 text: (
    //                   <Text
    //                     severity="action"
    //                     className="hover:underline cursor-pointer"
    //                     onClick={(_) => {
    //                       goToStep(0);
    //                       window.scrollTo({
    //                         top: 0,
    //                         behavior: 'smooth',
    //                       });
    //                     }}
    //                   >
    //                     <FontAwesomeIcon
    //                       icon={faEdit}
    //                       className="mr-1"
    //                     />
    //                     <span className="font-bold">
    //                       Edit Details
    //                     </span>
    //                   </Text>
    //                 ),
    //               }
    //             : null,
    //         ].filter((d) => d),
    //       },
    // ].filter((d) => d);

    const vehicleDetailsData = 
      buyHealthPolicy?.insuredDetails?.map((veh, idx) => {
       
        return {
          title: (
            <Text type="normal">
              {buyHealthPolicy?.insuredDetails?.[idx]?.VehicleType
              ||
              buyHealthPolicy?.insuredDetails?.[idx]?.relationship}
            </Text>
          ),
          grid_type: 'data',
          isBorderRequired: true,
          borderClassName: 'border-t-2 border-neutral pt-4',
          grid_data: [
          {
            label: 'Registration Number',
            text: (buyHealthPolicy?.insuredDetails?.[idx]?.vehicleRegNo?.part1+
            buyHealthPolicy?.insuredDetails?.[idx]?.vehicleRegNo.part2+
            buyHealthPolicy?.insuredDetails?.[idx]?.vehicleRegNo.part3+
            buyHealthPolicy?.insuredDetails?.[idx]?.vehicleRegNo.part4)
            || buyHealthPolicy?.insuredDetails?.[idx]?.vehicleRegNo
            ,
              
          },
          {
            label: 'VehicleMakeModel',
            text: buyHealthPolicy?.insuredDetails?.[idx]?.VehicleMake + '-' +
            buyHealthPolicy?.insuredDetails?.[idx]?.VehicleModel,
          },
          {
            label: 'Engine Number',
            text: buyHealthPolicy?.insuredDetails?.[idx]?.EngineNo,
          },
          {
            label: 'Chassis Number',
            text: buyHealthPolicy?.insuredDetails?.[idx]?.ChasisNo,
          },
          !buyHealthPolicy?.proposalNumber
            ? {
                colSpan: repeat,
                className: 'mt-2',
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(1);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <Text className="font-bold">Edit Details</Text>
                  </Text>
                ),
              }
            : null,
          // {
          //   label: 'Cubic Capacity',
          //   text: buyHealthPolicy?.insuredDetails?.[idx]?.RegistrationNumber,
          // },
          
           
        ].filter((d) => d),
      };
    })
    
    

    const prevInsuranceAndClaimsData = [
      {
        grid_type: 'data',
        title: 'Previous Policy',
        grid_data: [
          {
            label: 'Previous Insurer Name',
            text: getDomainData(
              rolloverCompanyList,
              buyHealthPolicy?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.previousInsurerName,
              'code',
              'value',
            ),
          },
          {
            label: 'Expiring Policy Number',
            text: buyHealthPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.expiringPolicyNumber,
          },
          {
            label: 'Policy/Cover Type',
            text: buyHealthPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyCoverType,
          },
          {
            label: 'Policy Start Date',
            text: buyHealthPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyStartDate,
          },
          {
            label: 'Policy Expiry Date',
            text: buyHealthPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyExpiryDate,
          },
          {
            label: 'Policy Tenure',
            text: buyHealthPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyTenureValue,
          },
        ],
      },
      {
        grid_type: 'data',
        title: 'Previous Claims',
        borderClassName: 'border-t-2 border-neutral pt-4',
        isBorderRequired: true,
        grid_data: [
          buyHealthPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
          'annual'
            ? {
                label: 'Total Claim Count',
                text: buyHealthPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.totalClaimCountValue,
              }
            : null,
          buyHealthPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term' &&
          buyHealthPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear1
            ? {
                label: 'No of Claims in Year 1',
                text: buyHealthPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.noOfClaimsYear1,
              }
            : null,
          buyHealthPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term' &&
          buyHealthPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear2
            ? {
                label: 'No of Claims in Year 2',
                text: buyHealthPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.noOfClaimsYear2,
              }
            : null,
          buyHealthPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term' &&
          buyHealthPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear3
            ? {
                label: 'No of Claims in Year 3',
                text: buyHealthPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.noOfClaimsYear3,
              }
            : null,
          {
            label: 'Total Claim Amount',
            text: buyHealthPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount
              ? CurrencyFormater(
                  `${buyHealthPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimAmount}`,
                  true,
                  false,
                  branding,
                )
              : '',
          },
          buyHealthPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
          'annual'
            ? {
                label: 'Previous Year NCB Slab',
                text: buyHealthPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.previousYearNCBSlab
                  ? `${buyHealthPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab} %`
                  : '',
              }
            : null,
          !buyHealthPolicy?.proposalNumber
            ? {
                colSpan: repeat,
                label: <div className="mt-4"></div>,
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(2);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <span className="font-bold">Edit Details</span>
                  </Text>
                ),
              }
            : null,
        ].filter((d) => d),
      },
    ];
    let nomi = 0;
    const nomineeDetailsData = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: 'Nominee Name',
            text: buyHealthPolicy?.nomineeDetails?.[nomi]
              ?.name,
          },
          {
            label: 'Nominee Date of Birth',
            text: buyHealthPolicy?.nomineeDetails?.[nomi]
            ?.dob,
          },
          {
            label: 'Relationship',
            text:buyHealthPolicy?.nomineeDetails?.[nomi]
                ?.insuredRelationship || buyHealthPolicy?.nomineeDetails?.[nomi]
                ?.relationship  ,
              
          },
          moment(new Date(), 'DD/MM/YYYY').diff(
            moment(
              buyHealthPolicy?.nomineeDetails?.[nomi]
            ?.dob,
              'DD/MM/YYYY',
            ),
            'years',
          ) < MINOR_THRESHOLD_AGE
            ? {
                label: 'Name of Appointee',
                text:buyHealthPolicy?.nomineeDetails?.[nomi]
                ?.nameOfAppointee,
              }
            : null,
          moment(new Date(), 'DD/MM/YYYY').diff(
            moment(
              buyHealthPolicy?.nomineeDetails?.[nomi]
                ?.nameOfAppointee,
              'DD/MM/YYYY',
            ),
            'years',
          ) < MINOR_THRESHOLD_AGE
            ? {
                label: 'Relationship with Appointee',
                text: 
                buyHealthPolicy?.nomineeDetails?.[nomi]
                ?.relationshipWithAppointee,
                  
                
              }
            : null,
          !buyHealthPolicy?.proposalNumber
            ? {
                colSpan: repeat,
                className: 'mt-2',
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(2);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <Text className="font-bold">Edit Details</Text>
                  </Text>
                ),
              }
            : null,
            
        ].filter((d) => d),
      },
     ];
    const financerDetailsData = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: 'Vehicle Owned/Financed',
            text: 'Self'
          },
          getDomainData(
            PRD_IsYourVehicle,
            buyHealthPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Financer Name',
                text: buyHealthPolicy?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.financerName,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            buyHealthPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Financer Address',
                text: buyHealthPolicy?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.financerAddress,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            buyHealthPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Financer Agreement Type',
                text: getDomainData(
                  PRD_FinancerAgreementType,
                  buyHealthPolicy?.additionalTabDetails?.financeDetails
                    ?.financerDetails?.financerAgreementType,
                  'code',
                  'value',
                ),
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            buyHealthPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Loan Account Number',
                text: buyHealthPolicy?.additionalTabDetails
                  ?.financeDetails?.financerDetails
                  ?.loanAccountNumber,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            buyHealthPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'File Number',
                text: buyHealthPolicy?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.fileNumber,
              }
            : null,
          !buyHealthPolicy?.proposalNumber
            ? {
                colSpan: repeat,
                className: 'mt-2',
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(2);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <Text className="font-bold">Edit Details</Text>
                  </Text>
                ),
              }
            : null,
        ].filter((d) => d),
      },
    ];
    const PApolicy = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: 'Name of Insurer',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Name_of_Insurer !== '' 
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Name_of_Insurer
            : '',
          },
          {
            label: 'Existing Policy Number',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Existing_PA_Policy_Number !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Existing_PA_Policy_Number
            : '',
          },
          {
            label: 'Existing Policy Sum Insured',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Existing_PA_Policy_Sum_Insured !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Existing_PA_Policy_Sum_Insured
            : '',
          },
          {
            label: 'Existing Policy Start Date',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Existing_PA_Policy_Start_Date !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Existing_PA_Policy_Start_Date
            : '',
          },
          {
            label: 'Existing Policy End Date',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Existing_PA_Policy_End_Date !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.Existing_PA_Policy_End_Date
            :'',
          },
          !buyHealthPolicy?.proposalNumber
            ? {
                colSpan: repeat,
                className: 'mt-2',
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(2);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <Text className="font-bold">Edit Details</Text>
                  </Text>
                ),
              }
            : null,
        ]
      }
    ]
    const Pastpolicy = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: 'Name of Insurer',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastinsurername !== '' 
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastinsurername
            : '',
          },
          {
            label: 'Previous Insurer Address',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastAddress !== '' 
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastAddress
            : '',
          },
          {
            label: 'Past Policy Number',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastpolicynumber !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastpolicynumber
            : '',
          },
          {
            label: 'Past Policy Sum Insured',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastsuminsured !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastsuminsured
            : '',
          },
          {
            label: 'Past Policy Start Date',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.paststartdate !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.paststartdate
            : '',
          },
          {
            label: 'Past Policy End Date',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastenddate !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastenddate
            :'',
          },
          {
            label: 'Property Description',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastpropertydescription !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastpropertydescription
            :'',
          },
          {
            label: 'Amount of Loss',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastamountofloss !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastamountofloss
            :'',
          },
          {
            label: 'Loss Location',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastlosslocation !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastlosslocation
            :'',
          },
          {
            label: 'Past Premium',
            text: buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastpremium !== ''
            ? buyHealthPolicy?.prevInsuranceDetails?.[nomi]?.pastpremium
            :'',
          },
          !buyHealthPolicy?.proposalNumber
            ? {
                colSpan: repeat,
                className: 'mt-2',
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(2);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <Text className="font-bold">Edit Details</Text>
                  </Text>
                ),
              }
            : null,
        ]
      }
    ]
    const otherPropsTopSection = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      textType: 'normal',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };

    const otherPropsForCards = {
      flow: 'cols',
      textType: 'normal',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      titleType: 'normal',
      useExpandablePaper: false,
      useGlobalExpandablePaper: true,
      globalTitleSeverity: 'info',
      globalTitleType: 'large',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };

    return (
      <QuantaForm className="space-y-4">
        <MixedGridGroup
          {...{ data: reviewAndConfirmData, ...otherPropsTopSection }}
        />
        <span>
          <ProposerCustomerReadOnly
            reactiveVarData={buyHealthPolicy}
            goToStep={goToStep}
            renderExpandedCards={renderExpandedCards}
          />
        </span>
        {/* <MixedGridGroup
          {...{
            data: proposerDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Proposer Details',
          }}
        /> */}
        <MixedGridGroup
          {...{
            data: vehicleDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Vehicle Details',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'vehicle details',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'vehicle details',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'vehicle details',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        />
        {(buyHealthPolicy?.quoteData?.businessTypeValue?.toLowerCase() ||
          buyHealthPolicy?.businessTypeValue?.toLowerCase() ===
            'roll over') &&
          buyHealthPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes' && (
            <MixedGridGroup
              {...{
                data: prevInsuranceAndClaimsData,
                ...otherPropsForCards,
                globalTitle: 'Previous Insurance & Claims Details',
                expanded: renderExpandedCards?.current?.find(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() ===
                    'previous insurance & claims details',
                )?.flag,
                isToggleEnabled: true,
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    ...renderExpandedCards?.current?.filter(
                      (card) =>
                        card?.cardName?.toString()?.toLowerCase() !==
                        'previous insurance & claims details',
                    ),
                    {
                      ...renderExpandedCards?.current?.find(
                        (card) =>
                          card?.cardName
                            ?.toString()
                            ?.toLowerCase() ===
                          'previous insurance & claims details',
                      ),
                      flag: expanded,
                    },
                  ];
                },
              }}
            />
          )}
        { <MixedGridGroup
          {...{
            data: nomineeDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Nominee Details',
          }}
        /> }
        { (buyHealthPolicy?.prevInsuranceDetails?.length > 0  &&
        (<MixedGridGroup
          {...{
            data: PApolicy,
            ...otherPropsForCards,
            globalTitle: 'PA Policy details',
          }}
        /> ))
        }
        { (buyHealthPolicy?.prevInsuranceDetails?.length > 0  && 
        (<MixedGridGroup
          {...{
            data: Pastpolicy,
            ...otherPropsForCards,
            globalTitle: 'Past Policy details',
          }}
        />
        )) }
        {/* <MixedGridGroup
          {...{
            data: financerDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Finance Details',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'finance details',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'finance details',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'finance details',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        /> */}
      </QuantaForm>
    );
  };
  return (
    <QuantaFormik
      innerRef={props?.forwardedRef}
      enableReinitialize={true}
      {...{
        initialValues,
        validate,
        onSubmit,
        validator: () => ({}),
      }}
    >
      <ReviewAndConfirmForm {...{ validate }} />
    </QuantaFormik>
  );
}
